'use es6';

import App from './App';
new App().start();